(function (angular) {
	'use strict';

	angular
		.module('iraModule')
		.controller('IraSignupStart', [
			'$document',
			'$timeout',
			'APP_BASE_PATH',
			'globalConfig',
			'HTTP_STATUS',
			'mixpanelFactory',
			'urlFactory',
			'vcRecaptchaService',
			IraSignupStartFunction
		]);

	function IraSignupStartFunction(
		$document,
		$timeout,
		APP_BASE_PATH,
		globalConfig,
		HTTP_STATUS,
		mixpanelFactory,
		urlFactory,
		vcRecaptchaService) {
		
		var signup = this;
		var widgetId;
		
		signup.$onInit = function() {
			mixpanelFactory.track('Signup Start IRA Viewed');
			angular.extend(signup, globalConfig);
			loadDocuments();
		};

		signup.setWidgetId = function(id){
			widgetId = id;
		};

		signup.resetRecaptcha = function(){
			vcRecaptchaService.reload(widgetId);
			signup.formSubmitted = false;
		};
		
		signup.initRecaptcha = function(){
			vcRecaptchaService.execute(widgetId);
		};

		signup.successfulRecaptcha = function(){
			signup.recaptchaResponse = vcRecaptchaService.getResponse(widgetId);

			$timeout(function(){
				signup.submit();
			});
		};

		signup.submit = function(){
			var postBody = {
				firstName: signup.firstName,
				lastName: signup.lastName,
				email: signup.email,
				password: signup.password,
				termsAcknowledgedVersionId: signup.termsOfService.documentRevisionId,
				privacyPolicyAcknowledgedVersionId: signup.privacyPolicy.documentRevisionId,
				signupCaptchaAnswer: signup.recaptchaResponse,
				clientId: signup.apiClientId
			};

			if(angular.isDefined(mixpanelFactory.getDistinctId())) {
				postBody.mixpanelId = mixpanelFactory.getDistinctId();
			}
			
			if(angular.isDefined(signup.universalControl)) {
				postBody.universalControl = signup.universalControl; 
			}
			
			urlFactory.apiPostPromise('/api/user', postBody)
				.then(function(response) {
					signup.accessToken = response.data.accessToken.access_token;
					signup.expiresIn = response.data.accessToken.expires_in;
					signup.refreshToken = response.data.accessToken.refresh_token;
					$timeout(function() {
						$document[0].getElementById('createUserSuccessForm').submit();
					});
				})
				.catch(function(response) {
					signup.resetRecaptcha();
					var override = {};

					if(response.status === HTTP_STATUS.CONFLICT) {
						override.email = 'A user with this email already exists. Please <a href="' + APP_BASE_PATH + '/login">log&nbsp;in</a> to proceed.';
						mixpanelFactory.track('Attempted Signup with Existing Email', { 'email': postBody.email });
					}

					urlFactory.handleServerValidation(signup.iraSignupStartForm, response, override);
				});
		};
		
		function loadDocuments() {
			var websiteDocumentsUrl = '/api/website-documents/terms-of-service-privacy-policy';

			urlFactory.apiGetPromise(websiteDocumentsUrl)
				.then(function (response) {
					signup.privacyPolicy = {
							documentRevisionId: response.data.privacyPolicy.documentRevisionId,
							title: response.data.privacyPolicy.title,
							url:  response.data.privacyPolicy.url
					};
					signup.termsOfService = {
							documentRevisionId: response.data.termsOfService.documentRevisionId,
							title: response.data.termsOfService.title,
							url:  response.data.termsOfService.url
					};
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					signup.iraSignupStartForm.$setValidity('documentLoadError', false);
				});
		}
	}
})(window.angular);